__webpack_require__.p = "/sqs-lambda-assistant/";